/**
 * Replay API - Fetch match replays
 */

import { http } from './http';

interface ReplayCard {
  id: string;
  rank: string;
  suit: string;
}

interface ReplayPlayer {
  wallet: string;
  username: string;
  score: number;
  hearts: number;
  hand: ReplayCard[];
  jokerIds: string[];
}

interface ReplaySnapshot {
  turn: number;
  phase: string;
  timestamp: number;
  players: Record<string, ReplayPlayer>;
  activePlayer: string;
  action?: {
    type: 'play_hand' | 'buy_joker' | 'skip_shop' | 'reroll';
    playedCards?: ReplayCard[];
    handType?: string;
    score?: number;
    jokerId?: string;
  };
}

export interface ReplaySummary {
  matchId: string;
  players: Array<{ wallet: string; username: string }>;
  wagerAmount: number;
  currency: string;
  winner?: string;
  finalScores?: Record<string, number>;
  snapshotCount: number;
  createdAt: string;
  completedAt?: string;
}

export interface FullReplay extends ReplaySummary {
  snapshots: ReplaySnapshot[];
}

interface RecentReplaysResponse {
  replays: ReplaySummary[];
}

export const replaysApi = {
  getRecent: async (limit = 20): Promise<ReplaySummary[]> => {
    const response = await http.get<RecentReplaysResponse>(`/replays/recent?limit=${limit}`);
    return response.replays;
  },

  getReplay: async (matchId: string): Promise<FullReplay> => {
    return http.get<FullReplay>(`/replays/${matchId}`);
  },

  getPlayerReplays: async (wallet: string, limit = 10): Promise<ReplaySummary[]> => {
    const response = await http.get<RecentReplaysResponse>(
      `/replays/player/${wallet}?limit=${limit}`,
    );
    return response.replays;
  },
};
